export default __webpack_public_path__ + "static/media/minicard5.4bece727.jpg";